import axios from "axios";

const API_URL = "http://localhost:8000";
const API_WEB_URL = "https://roanprojects.000webhostapp.com";

const HouseService = () => {
  const getHouses = async () => {
    const res = await axios.get(`/getHouses`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  };
  const getSaleHouses = async () => {
    const res = await axios.get(`/getSaleHouses`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  };
  const getRentHouses = async () => {
    const res = await axios.get(`/getRentHouses`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  };
  const getRecentHouses = async () => {
    const res = await axios.get(`/getRecentHouses`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  };

  const addHouse = async (house) => {
    const res = await axios.post(`/addHouse`, house, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log(res);
    return res.data;
  };

  const editHouse = async (house) => {
    const res = await axios.post(`/editHouse`, house, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log(res);
    return res.data;
  };

  const deleteHouse = async (house) => {
    const res = await axios.post(`/deleteHouse`, house, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  };
  return {
    getRecentHouses,
    getSaleHouses,
    getRentHouses,
    getHouses,
    addHouse,
    editHouse,
    deleteHouse,
  };
};

export default HouseService;
